import { useCallback, useEffect, useRef } from 'react';
import { SITE_URL } from '../env';
import moment from 'moment';

export default () => {
  const needToRefresh = useRef(false);
  // Launch versioning timer every 5min
  useEffect(() => {
    // Check app version at start
    checkAppVersion();
    // And check it every 5min
    const timerId = setInterval(checkAppVersion, 300000);

    return () => clearInterval(timerId);
  }, [needToRefresh]);

  const checkAppVersion = () => {
    // Check new version only if we don't need to refresh
    if (!needToRefresh.current) {
      console.log('CHECKING NEW VERSION ...');

      fetch(SITE_URL + `?cache-bust=${moment().valueOf()}`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache',
          pragma: 'no-cache',
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.text();
          }
        })
        .then((body) => {
          const res = (body || '').match(/\/bundle\.([^\.]*)\.js/i);
          if (res && res.length > 1) {
            const currentVersion = getCurrentAppVersion();
            console.log('CURRENT VERSION: ' + currentVersion);
            if (currentVersion !== res[1]) {
              console.log('NEW VERSION AVAILABLE');
              needToRefresh.current = true;
            }
            console.log('VERSION: ' + res[1]);
          }
        });
    }
  };

  const getCurrentAppVersion = () => {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const matches = (scripts[i].src || '').match(/\/bundle\.([^\.]*)\.js/i);
      if (matches && matches.length > 1) {
        return matches[1];
      }
    }
    return '';
  };

  const refreshCacheAndReload = useCallback(() => {
    if (caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });
    }

    // delete browser cache and hard reload
    window.location.reload(true);
  }, []);

  return {
    needToRefresh,
    refreshCacheAndReload,
  };
};
